export { default } from './GridOrdersBooking.vue'
